import { LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import "./TableSearchBar.scss";
type Props = {
  onSearch: React.ChangeEventHandler<HTMLInputElement>;
  isSearching: boolean;
  disabled: boolean;
};
const TableSearchBar: React.FC<Props> = ({
  onSearch,
  isSearching,
  disabled,
}) => {
  return (
    <div>
      <Input
        className="search-bar"
        placeholder="Recherche"
        allowClear
        onChange={onSearch}
        prefix={
          isSearching ? (
            <LoadingOutlined style={{ color: "rgba(0,0,0,.25)" }} />
          ) : (
            <SearchOutlined style={{ color: "rgba(0,0,0,.25)" }} />
          )
        }
        disabled={isSearching || disabled}
      />
    </div>
  );
};

export default TableSearchBar;
